import StyledDataGridToolbar from '@/components/datagrid/StyledDataGridToolbar';
import { useTranslation } from 'react-i18next';

const UnitDataGridToolbar = ({ ...props }) => {
  const { t } = useTranslation('translation');

  return (
    <StyledDataGridToolbar
      placeholder="Units"
      buttonTitle={t('translation:new')}
      dialogTitle="Add New Unit"
      {...props}
    />
  );
};

export default UnitDataGridToolbar;
